import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/tHome.vue'
import Burial from '@/components/tBurial.vue'
import Unsubscribe from '../components/tUnsubscribe.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/burial/:public_id',
    name: 'Burial',
    component: Burial
  },
  {
    path: '/unsubscribe/:email',
    name: 'Unsubscribe',
    component: Unsubscribe
  }
]

const router = new Router({
  routes,
  mode: 'history'
})

export default router
